import { FC, useCallback, useEffect, useState } from 'react';
import { IconButton, Modal, Stack } from '@fluentui/react';
import { DeleteRegular, AddRegular } from '@fluentui/react-icons';
import { JobRole } from '../../../api';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import LocationInput from '../../../components/LocationInput';

type TEditJobRoleModal = FC<{
  isOpen: boolean;
  jobRole?: JobRole;
  onSubmit: (jobRole: JobRole) => void;
  onCancel: () => void;
}>;

const blankJobRole: JobRole = {
  Company: '',
  Job: '',
  Discipline: '',
  Industry1: '',
  Location: '',
  Sector: '',
  Seniority: '',
  Consultant: '',
};

const EditJobRoleModal: TEditJobRoleModal = ({ isOpen, jobRole: _jobRole, onSubmit, onCancel }) => {
  const [jobRole, setJobRole] = useState<JobRole>(_jobRole || { ...blankJobRole });
  const isValid =
    jobRole.Company != '' &&
    jobRole.Job != '' &&
    jobRole.Discipline != '' &&
    jobRole.Industry1 != '' &&
    jobRole.Location != '' &&
    jobRole.Sector != '' &&
    jobRole.Seniority != '' &&
    jobRole.Consultant != '';

  useEffect(() => {
    setJobRole(_jobRole || { ...blankJobRole });
  }, [_jobRole, isOpen]);

  const updateJobRole = useCallback(
    (key: keyof JobRole, value: string) => {
      if (jobRole[key] == value) return;

      setJobRole({ ...jobRole, [key]: value });
    },
    [jobRole],
  );

  return (
    <Modal isOpen={isOpen} onDismiss={onCancel} isBlocking={true}>
      <div style={{ padding: '20px', position: 'relative' }}>
        <IconButton
          iconProps={{ iconName: 'Cancel' }}
          onClick={onCancel}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
          }}
        />
        <h2>{_jobRole ? 'Edit' : 'Add'} a Job Role</h2>
        <Stack>
          <TextInput
            label="Company"
            value={jobRole.Company}
            onChange={value => updateJobRole('Company', value)}
            required
          />
          <TextInput label="Job Title" value={jobRole.Job} onChange={value => updateJobRole('Job', value)} required />
          <TextInput
            label="Discipline"
            value={jobRole.Discipline}
            onChange={value => updateJobRole('Discipline', value)}
            required
          />
          <TextInput
            label="Industry"
            value={jobRole.Industry1}
            onChange={value => updateJobRole('Industry1', value)}
            required
          />
          <LocationInput
            label="Location"
            value={jobRole.Location}
            onChange={value => updateJobRole('Location', value)}
            required
          />
          <TextInput
            label="Sector"
            value={jobRole.Sector}
            onChange={value => updateJobRole('Sector', value)}
            required
          />
          <TextInput
            label="Seniority"
            value={jobRole.Seniority}
            onChange={value => updateJobRole('Seniority', value)}
            required
          />
          <TextInput
            label="Consultant"
            value={jobRole.Consultant}
            onChange={value => updateJobRole('Consultant', value)}
            required
          />
        </Stack>
        <Stack horizontal style={{ justifyContent: 'space-between', gap: '8px', margin: '8px 8px 0' }}>
          <Button label="Cancel" backgroundColor="red" color="white" icon={DeleteRegular} onClick={onCancel} />
          <Button
            label="Save"
            backgroundColor="green"
            color="white"
            icon={AddRegular}
            onClick={() => onSubmit(jobRole)}
            disabled={!isValid}
          />
        </Stack>
      </div>
    </Modal>
  );
};

export default EditJobRoleModal;
